import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { FamilyInviteModalProps } from './FamilyInviteModal.types';

export const openFamilyInviteModal = (data?: FamilyInviteModalProps) =>
    openPopupHelper({ popupName: popupNames.FAMILY_INVITE_MODAL, data, onClose: data?.onClose });
